/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { StoreProvider } from "easy-peasy";
import { isEmpty } from "lodash";
import { isIE } from "react-device-detect";
import model from "../../store/model";
import DemoScreen from "../DemoScreen";
import RotateIndicator from "../RotateIndicator";
import BGMPlayer from "../BGMPlayer";
import { isMobile } from "../../utils/ResponsiveUtils";

const InteractiveExperience = ({ data }) => {
  const { product, intro, outro, demo, rotateIndicator, start } = data;
  const { audioTrack } = demo || "";
  const { alternativeAudioTrack } = demo || "";
  const store = model;

  return (
    <>
      <StoreProvider store={store}>
        {!isEmpty(data) && (
          <>
            {demo.showFeatures ? (
              <RotateIndicator content={{ ...rotateIndicator, ...start }} />
            ) : null}
            {isIE ? (
              <BGMPlayer source={alternativeAudioTrack} type="audio/mpeg" />
            ) : (
              <BGMPlayer source={audioTrack} type="audio/aac" />
            )}

            <DemoScreen
              content={demo}
              intro={intro}
              outro={outro}
              product={product}
            />
          </>
        )}
      </StoreProvider>
    </>
  );
};

InteractiveExperience.propTypes = {
  data: PropTypes.shape({
    start: PropTypes.object,
    product: PropTypes.object,
    intro: PropTypes.object,
    outro: PropTypes.object,
    demo: PropTypes.object,
    rotateIndicator: PropTypes.object,
  }),
};
InteractiveExperience.defaultProps = {
  data: {},
};

export default InteractiveExperience;
